import Dialog from '@ergeon/core-components/exports/Dialog.ts';
import PopUp from '@ergeon/core-components/exports/PopUp.ts';
import { ExclamationTriangleIcon } from '@ergeon/icons/hero/solid';
import { AdjustmentsHorizontalIcon } from '@ergeon/icons/hero/mini';

import { Permissions } from '@/app/types';

interface ResetPermissionsModalProps {
  onClose(): void;
  permissions: Permissions;
}

export default function ResetPermissionsModal({ onClose, permissions }: ResetPermissionsModalProps) {
  const getPermissionsLabel = (permissions: Permissions): string => {
    const { audio, video } = permissions;
    return [audio && 'microphone', video && 'camera'].filter(Boolean).join(' and ');
  };

  return (
    <PopUp isVisible maxWidth="small" onChangeVisible={onClose}>
      <Dialog
        hideCancelButton
        icon={<ExclamationTriangleIcon className="size-6 text-orange-500 dark:text-orange-400" />}
        isVisible
        onDismiss={onClose}
        onSubmit={onClose}
        submitButtonFlavor="primary"
        submitButtonText="Ok"
        title="Grant permissions to continue">
        <ol className="flex list-inside list-decimal flex-col gap-2">
          <li>
            Click the <AdjustmentsHorizontalIcon className="inline-block size-5 align-text-bottom" /> in your browser's address bar
          </li>
          <li>
            Clear {getPermissionsLabel(permissions)} permission
          </li>
          <li>
            Refresh the page
          </li>
        </ol>
      </Dialog>
    </PopUp>
  );
}
